import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { insiderMembershipInvoiceDownload } from "@faire/retailer-visitor-shared/lib/insiderMembershipInvoiceDownload";
import { useCallback, useState } from "react";
/** Provides state and actions for downloading an Insider membership invoice. */ export function useInsiderMembershipInvoiceDownload() {
    var _useState = _sliced_to_array(useState(), 2), downloadingInvoiceToken = _useState[0], setDownloadingInvoiceToken = _useState[1];
    var downloadInvoice = useCallback(function(invoice) {
        return setDownloadingInvoiceToken(function(current) {
            if (!current) {
                var paymentDate = invoice.membership_payment_date ? new Date(invoice.membership_payment_date) : new Date();
                var fileName = "membership-invoice-".concat(paymentDate.toISOString().split("T")[0], ".pdf");
                insiderMembershipInvoiceDownload(fileName, invoice.token).finally(function() {
                    return setDownloadingInvoiceToken(undefined);
                });
                return invoice.token;
            }
            return current;
        });
    }, []);
    return {
        isLoading: !!downloadingInvoiceToken,
        downloadingInvoiceToken: downloadingInvoiceToken,
        downloadInvoice: downloadInvoice
    };
}
